export const MENU_CHAT = "MENU_CHAT";

export function hasFeature(member: { features?: string[] } | null | undefined, feature: string): boolean {
  return !!member?.features?.includes(feature);
}
